import Action from './action';
import { HEADER_TYPES, MENU_TYPE } from '../../../Utils/enums';
import $ from 'jquery';
import 'jquery.cookie';

/**
 * Default Data
 */
const initialState = {
  progressBar: {
    open: false, // 프로그래스 바 상태
    message: '잠시만 기다려주세요.', // 프로그래스 바 메시지
  },
  progressBarList: [],

  snackBar: {
    message: '', // 스낵바 메시지
    open: false, // 스낵바 상태
    type: '', // 스낵바 타입
  },
  dialog: {
    open: false,
    useIcon: false,
    useIconType: 'success',
    closeIcon: false,
    closeLabel: '',
    confirmLabel: '',
    onClose: () => {},
    onConfirm: () => {},
  },
  sampleData: 'test', // 샘플데이터

  menuType: MENU_TYPE.DEFAULT, // 메뉴 타입

  invoice: { invoiceItemDtoList: [] }, // invoice 상세조회
  isInvoiceDetailPopup: false, // invoice 상세정보 팝업 Flag
  isInvoiceSearchView: false, //invoice 조회 View Flag
  invoiceList: {
    content: [],
    page: { size: 0, totalElements: 0, totalPages: 0 },
  }, // invoice 조회 리스트
  invoiceListTotalAmount: {
    totalAmount: 0,
    totalNetItemSalesAmount: 0,
    vatAmount: 0,
    total: 0,
    vat: 0,
    zeroRate: 0,
    exempt: 0,
  },
  invoiceCorrectList: {}, // 상세조회 Correct 히스토리 리스트
  invoiceCorrectDetail: { invoiceItemDtoList: [] },
  invoiceIssueInfo: {}, // invoice 발행 후 정보
  invoiceCheckIssuePopup: false,
  invoicePreviewPopup: false,
  invoiceSavePopup: false,
  invoiceSaveCompletePopup: false,
  invoiceIssueCompletePopup: false,
  isInvoiceInit: false,
  MassiveIssuanceVerificationResult: [], //excel 대량 업로드 결과 조회
  clientList: { content: [], page: {} }, // 거래처리스트
  isClientDetailPopup: false, // 거래처 상세보기 팝업
  uploadClientList: {}, // 엑셀업로드 거래처 리스트
  // isTradeRegisteredNameCheck: false, // 거래처 tradeName 중복체크
  isClientSearchView: false, // 거래처 휴폐업 조회 View Flag
  clientStatus: {}, // 거래처 휴폐업 정보

  itemList: { content: [], page: {} }, // 품목리스트
  isItemDetailPopup: false, // 품목 상세보기 팝업
  uploadItemList: {}, // 엑셀업로드 품목 리스트

  advisoryList: [], // 공지사항리스트
  advisoryDetail: {
    systemCode: 'EX',
  }, // 공지사항 상세정보
  advisoryPage: 0,

  boardList: [], // Board 리스트
  boardDetail: {
    boardDto: {
      boardNo: '',
    },
  }, // Board 상세정보
  faqPage: {
    tabType: 'ALL',
    page: 0,
  },

  encryptPasswordKey: '', // 비밀번호 암호화 키
  user: {
    authToken: '',
    userNo: '',
    contactNo: '',
    email: '',
    firstName: '',
    middleName: '',
    lastName: '',
    portalId: '',
    password: '',
    userAuthStatusCode: {},
    userTin: '',
    userBranchCode: '',
    certificateFileAddr: '',
    employee: [
      {
        employeeNo: '',
        company: {
          companyNo: '',
          tin: '',
          branchCode: '',
          businessName: '',
          companyTypeCode: '',
          contactNo: '',
          email: '',
          registeredName: '',
          companyAuthStatusCode: '',
          addrUnit: '',
          addrBuildingName: '',
          addrLot: '',
          addrStreetName: '',
          addrSubdivision: '',
          addrBarangay: '',
          addrTown: '',
          addrMunicipality: '',
          addrProvince: '',
          contactPerson: '',
          transactionClassification: '',
          documentTypeCode: '',
          roundUpCode: '',
        },
      },
    ],
  },
  company: {
    companyNo: '',
    tin: '',
    branchCode: '',
    businessName: '',
    companyTypeCode: '',
    companyType: {},
    contactNo: '',
    email: '',
    registeredName: '',
    companyAuthStatusCode: '',
    addrUnit: '',
    addrBuildingName: '',
    addrLot: '',
    addrStreetName: '',
    addrSubdivision: '',
    addrBarangay: '',
    addrTown: '',
    addrMunicipality: '',
    addrProvince: '',
    contactPerson: '',
    transactionClassification: '',
    documentTypeCode: '',
    roundUpCode: '',
    employee: [
      {
        employeeNo: '',
        user: {
          userNo: '',
          contactNo: '',
          email: '',
          firstName: '',
          middleName: '',
          lastName: '',
          portalId: '',
          password: '',
          userAuthStatusCode: {},
          userTin: '',
          userBranchCode: '',
          certificateFileAddr: '',
        },
      },
    ],
  },

  mail: {
    isSuccess: '', //인증번호 메일 Flag
    // companyEmail: '',
  },

  checkElement: {
    isTin: false, // TIN 체크
    isId: false, // 회원가입 ID 체크
    isSignUpSuccess: false, // 회원가입 성공여부
    isPassword: 0, // 비밀번호 일치 여부
    isTradeTin: null,
    isTradeRegisteredName: null, //tradeRegisteredName 중복 여부
    isItemName: null, //ItemName 중복여부
  },

  isStatisticsSumPopup: false, // Statistics Sum 팝업 Flag
  isStatisticsPeriodPopup: false, // Statistics Period 팝업 Flag
  statisticsSum: '',
  statisticsSumDetail: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    content: [],
  },
  statisticsPeriod: [],
  statisticsPeriodDetail: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    content: [],
  },
  statisticsType: [],
  statisticsSumPopup: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    content: [],
  },
  statisticsPeriodPopup: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    content: [],
  },

  codeList: [],
  userList: [],

  taxpayerDetail: {},

  // 내부(internal) 관련
  vatMonthlyList: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    content: [],
  },
  vatMonthlyDetail: {},
  vatQuarterlyList: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    content: [],
  },
  vatQuarterlyDetail: {},

  //jws viewer 관련
  jwsInfo: {
    CompInvoiceId: '',
    IssueDtm: '',
    EisUniqueId: '',
    DocType: '',
    TransClass: '',
    CorrYN: '',
    CorrectionCd: '',
    PrevUniqueId: '',
    Rmk1: '',
    SellerInfo: {
      Tin: '',
      BranchCd: '',
      Type: '',
      RegNm: '',
      BusinessNm: '',
      Email: '',
      RegAddr: '',
    },
    BuyerInfo: {
      Tin: '',
      BranchCd: '',
      RegNm: '',
      BusinessNm: '',
      Email: '',
      RegAddr: '',
      DevAddr: '',
      AirNum: '',
      AirNumDt: '',
      LadNum: '',
      LadNumDt: '',
    },
    ItemList: [
      {
        Nm: '',
        Desc: '',
        Qty: '',
        Unit: '',
        UnitCost: '',
        SalesAmt: '',
        RegDscntAmt: '',
        SpeDscntAmt: '',
        NetSales: '',
      },
    ],
    TotNetItemSales: '',
    Discount: {
      ScAmt: '',
      PwdAmt: '',
      RegAmt: '',
      SpeAmt: '',
      Rmk2: '',
    },
    OtherTaxRev: '',
    TotNetSalesAftDisct: '',
    VATAmt: '',
    WithholdIncome: '',
    WithholdBusVAT: '',
    WithholdBusPT: '',
    OtherNonTaxCharge: '',
    NetAmtPay: '',
    ForCur: {
      Currency: '',
      ForexAmt: '',
      ConvRate: '',
    },
    PtuNum: '',
    PtuExpDt: '',
    Min: '',
    Msn: '',
    VATSales: '',
    ExemptSales: '',
    ZeroSales: '',
    TotSalesAmt: '',
  },
};

function copyObj(obj) {
  var copy = {};
  if (Array.isArray(obj)) {
    copy = obj.slice().map((v) => {
      return copyObj(v);
    });
  } else if (typeof obj === 'object' && obj !== null) {
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = copyObj(obj[attr]);
      }
    }
  } else {
    copy = obj;
  }
  return copy;
}

export default (state = initialState, action) => {
  const { payload } = action;

  switch (action.type) {
    case Action.setProgressBar.SUCCESS:
      return { ...state, progressBar: payload };
    case Action.addProgressBar.SUCCESS:
      var orgState = { ...state };
      var index = orgState.progressBarList.indexOf(payload);

      if (index === -1) {
        orgState.progressBarList.push(payload);
      }

      return {
        ...state,
        progressBarList: orgState.progressBarList,
      };
    case Action.removeProgressBar.SUCCESS:
      var orgState = { ...state };
      var index = orgState.progressBarList.indexOf(payload);

      if (index !== -1) {
        orgState.progressBarList.splice(index, 1);
        return { ...state, progressBarList: orgState.progressBarList };
      }

      return { ...state };
    case Action.setSnackBar.SUCCESS:
      return { ...state, snackBar: payload };
    case Action.closeSnackBar.SUCCESS:
      return {
        ...state,
        snackBar: {
          autoHideDuration: 0,
          message: '',
          open: false,
          type: '',
        },
      };
    case Action.setDialog.SUCCESS:
      return { ...state, dialog: { ...payload } };
    case Action.setMenuType.SUCCESS:
      return { ...state, menuType: payload };

    case Action.getCode.SUCCESS:
      for (var i = 0; i < payload.length; i++) {
        Object.defineProperty(
          payload[i],
          'codeList',
          Object.getOwnPropertyDescriptor(payload[i], 'codeDtoList')
        );
        delete payload[i]['codeDtoList'];
      }

      return { ...state, codeList: payload };

    case Action.getCode.FAILURE:
      var code = copyObj(initialState.code);
      return { ...state, code };
    case Action.initCode.TRIGGER:
      return {
        ...state,
        codeList: [],
      };
    case Action.initCheckElement.SUCCESS:
      return { ...state, checkElement: copyObj(initialState.checkElement) };

    case Action.getInvoice.SUCCESS:
      return { ...state, invoice: payload };
    case Action.getInvoiceList.SUCCESS:
      return { ...state, invoiceList: payload };
    case Action.setInvoiceList.SUCCESS:
      return { ...state, invoiceList: payload };
    case Action.setInvoiceListTotalAmount.SUCCESS:
      return { ...state, invoiceListTotalAmount: payload };
    case Action.getInvoiceDetail.SUCCESS:
      return { ...state, invoice: payload };
    case Action.isInvoiceDetailPopup.SUCCESS:
      return { ...state, isInvoiceDetailPopup: payload };
    case Action.isInvoiceSearchView.SUCCESS:
      return { ...state, isInvoiceSearchView: payload };
    case Action.getInvoiceCorrectList.SUCCESS:
      return { ...state, invoiceCorrectList: payload };
    case Action.getInvoiceCorrectDetail.SUCCESS:
      return {
        ...state,
        invoiceCorrectDetail: payload,
      };
    case Action.initInvoiceCorrectDetail.TRIGGER:
      return {
        ...state,
        invoiceCorrectDetail: { invoiceItemDtoList: [] },
      };
    case Action.initInvoice.TRIGGER:
      return {
        ...state,
        invoice: { invoiceItemDtoList: [] },
        invoiceList: { page: { size: 0, totalElements: 0, totalPages: 0 } },
        invoiceListTotalAmount: {
          totalAmount: 0,
          totalNetItemSalesAmount: 0,
          vatAmount: 0,
          total: 0,
          vat: 0,
          zeroRate: 0,
          exempt: 0,
        },
        isInvoiceSearchView: false,
        isInvoiceDetailPopup: false,
        invoiceCheckIssuePopup: false,
        invoicePreviewPopup: false,
        invoiceSavePopup: false,
        invoiceSaveCompletePopup: false,
        invoiceIssueCompletePopup: false,
        isInvoiceInit: false,
        invoiceCorrectList: {},
        invoiceCorrectDetail: { invoiceItemDtoList: [] },
        MassiveIssuanceVerificationResult: [],
      };
    case Action.setIssuanceInvoiceList.SUCCESS:
      return {
        ...state,
        invoiceList: { ...state.invoiceList, content: payload },
      };
    case Action.invoiceIssueInfo.SUCCESS:
      return { ...state, invoiceIssueInfo: payload };
    case Action.initInvoiceIssueInfo.TRIGGER:
      return { ...state, invoiceIssueInfo: {} };
    case Action.invoiceCheckIssuePopup.SUCCESS:
      return { ...state, invoiceCheckIssuePopup: payload };
    case Action.invoicePreviewPopup.SUCCESS:
      return { ...state, invoicePreviewPopup: payload };
    case Action.invoiceSavePopup.SUCCESS:
      return { ...state, invoiceSavePopup: payload };
    case Action.invoiceSaveCompletePopup.SUCCESS:
      return { ...state, invoiceSaveCompletePopup: payload };
    case Action.invoiceIssueCompletePopup.SUCCESS:
      return { ...state, invoiceIssueCompletePopup: payload };
    case Action.isInvoiceInit.SUCCESS:
      return { ...state, isInvoiceInit: payload };
    case Action.getMassiveIssuanceVerificationResult.SUCCESS:
      return { ...state, MassiveIssuanceVerificationResult: payload };

    case Action.getClientList.SUCCESS:
      return { ...state, clientList: payload };
    case Action.setClientList.SUCCESS:
      return {
        ...state,
        clientList: { ...state.clientList, content: payload },
      };
    case Action.setUploadClientList.SUCCESS:
      return { ...state, uploadClientList: payload };
    case Action.isClientDetailPopup.SUCCESS:
      return { ...state, isClientDetailPopup: payload };
    case Action.initClientList.TRIGGER:
      return {
        ...state,
        clientList: { content: [], page: {} },
        checkElement: {
          ...state.checkElement,
          // isTin: false, // TIN 체크
          isTradeTin: null,
          isTradeRegisteredName: null,
        },
        isClientSearchView: false,
        clientStatus: {},
        uploadClientList: {},
      };
    case Action.tradeTinCheck.SUCCESS:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isTradeTin: payload,
        },
      };

    case Action.isTradeTinCheck.SUCCESS:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isTradeTin: payload,
        },
      };

    case Action.tradeRegisteredNameCheck.SUCCESS:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isTradeRegisteredName: payload,
        },
      };

    case Action.isTradeRegisteredNameCheck.SUCCESS:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isTradeRegisteredName: payload,
        },
      };

    case Action.getClientStatus.SUCCESS:
      return {
        ...state,
        isClientSearchView: true,
        clientStatus: payload,
      };

    case Action.getItemList.SUCCESS:
      return { ...state, itemList: payload };
    case Action.setItemList.SUCCESS:
      return { ...state, itemList: { ...state.itemList, content: payload } };
    case Action.setUploadItemList.SUCCESS:
      return { ...state, uploadItemList: payload };
    case Action.isItemDetailPopup.SUCCESS:
      return { ...state, isItemDetailPopup: payload };
    // case Action.itemNameCheck.SUCCESS:
    //   return { ...state, itemNameCheck: payload };
    case Action.initItemList.TRIGGER:
      return {
        ...state,
        itemList: { content: [], page: {} },
        uploadItemList: {},
      };
    case Action.isItemNameCheck.SUCCESS:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isItemName: payload,
        },
      };

    case Action.getAdvisoryList.SUCCESS:
      return { ...state, advisoryList: payload };
    case Action.getAdvisoryDetail.SUCCESS:
      return { ...state, advisoryDetail: payload };
    case Action.initAdvisoryList.TRIGGER:
      return {
        ...state,
        advisoryList: [],
      };
    case Action.initAdvisoryDetail.TRIGGER:
      return {
        ...state,
        advisoryDetail: {
          systemCode: 'EX',
        },
      };
    case Action.setAdvisoryPage.TRIGGER:
      return {
        ...state,
        advisoryPage: payload,
      };

    case Action.getBoardList.SUCCESS:
      return { ...state, boardList: payload };
    case Action.getBoardDetail.SUCCESS:
      return { ...state, boardDetail: payload };
    case Action.initBoardList.TRIGGER:
      return {
        ...state,
        boardList: [],
      };
    case Action.initBoardDetail.TRIGGER:
      return {
        ...state,
        boardDetail: {
          boardDto: {
            boardNo: '',
          },
        },
      };
    case Action.setFaqPage.TRIGGER:
      return {
        ...state,
        faqPage: payload,
      };

    case Action.getEncryptPasswordKey.SUCCESS:
      return { ...state, encryptPasswordKey: payload };

    case Action.signIn.SUCCESS:
      return { ...state, user: payload.data };

    case Action.signIn.FAILURE:
      var stateUser = { ...initialState.user };
      if (payload.status === 502) {
        stateUser.userAuthStatusCode.code = '99';
      } else if (payload.status === 403) {
        stateUser.userAuthStatusCode.code = '98';
      } else if (payload.status === 404) {
        stateUser.userAuthStatusCode.code = '99';
      }

      return { ...state, user: stateUser };

    case Action.signOut.SUCCESS:
      return {
        // ...state,
        // user: {
        //   authToken: '',
        //   userNo: '',
        //   contactNo: '',
        //   email: '',
        //   firstName: '',
        //   middleName: '',
        //   lastName: '',
        //   portalId: '',
        //   password: '',
        //   userAuthStatusCode: {},
        //   userTin: '',
        //   userBranchCode: '',
        //   certificateFileAddr: '',
        //   employee: [
        //     {
        //       employeeNo: '',
        //       company: {
        //         companyNo: '',
        //         tin: '',
        //         branchCode: '',
        //         businessName: '',
        //         companyTypeCode: '',
        //         contactNo: '',
        //         email: '',
        //         registeredName: '',
        //         companyAuthStatusCode: '',
        //         addrUnit: '',
        //         addrBuildingName: '',
        //         addrLot: '',
        //         addrStreetName: '',
        //         addrSubdivision: '',
        //         addrBarangay: '',
        //         addrTown: '',
        //         addrMunicipality: '',
        //         addrProvince: '',
        //         contactPerson: '',
        //         transactionClassification: '',
        //         documentTypeCode: '',
        //         roundUpCode: '',
        //       },
        //     },
        // ],
        // },
        ...initialState,
      };

    case Action.searchId.SUCCESS:
      sessionStorage.setItem('searchId_portalId', payload.data.portalId);
      return { ...state, user: payload.data };

    case Action.searchPw.SUCCESS:
      var user = { ...state.user };

      Object.keys(payload.data).map((key) => {
        if (user[key] == undefined) {
          return;
        }
        user[key] = payload.data[key];
      });

      return { ...state, user: user };

    case Action.sendSearchPwMail.SUCCESS:
      return {
        ...state,
        mail: {
          isSuccess: true,
          // companyEmail: payload.data,
        },
      };

    case Action.initMail.TRIGGER:
      return {
        ...state,
        mail: {
          isSuccess: '',
          // companyEmail: '',
        },
      };
    case Action.resetPassword.SUCCESS:
      return { ...state };

    case Action.initCompany.SUCCESS:
      return {
        ...state,
        company: {
          companyNo: '',
          tin: '',
          branchCode: '',
          businessName: '',
          companyTypeCode: '',
          companyType: {},
          contactNo: '',
          email: '',
          registeredName: '',
          companyAuthStatusCode: '',
          addrUnit: '',
          addrBuildingName: '',
          addrLot: '',
          addrStreetName: '',
          addrSubdivision: '',
          addrBarangay: '',
          addrTown: '',
          addrMunicipality: '',
          addrProvince: '',
          contactPerson: '',
          transactionClassification: '',
          documentTypeCode: '',
          roundUpCode: '',
          employee: [
            {
              employeeNo: '',
              user: {
                userNo: '',
                contactNo: '',
                email: '',
                firstName: '',
                middleName: '',
                lastName: '',
                portalId: '',
                password: '',
                userAuthStatusCode: {},
                userTin: '',
                userBranchCode: '',
                certificateFileAddr: '',
              },
            },
          ],
        },
      };

    case Action.initUser.SUCCESS:
      return {
        ...state,
        user: {
          authToken: '',
          userNo: '',
          contactNo: '',
          email: '',
          firstName: '',
          middleName: '',
          lastName: '',
          portalId: '',
          password: '',
          userAuthStatusCode: {},
          userTin: '',
          userBranchCode: '',
          certificateFileAddr: '',
          employee: [
            {
              employeeNo: '',
              company: {
                companyNo: '',
                tin: '',
                branchCode: '',
                businessName: '',
                companyTypeCode: '',
                contactNo: '',
                email: '',
                registeredName: '',
                companyAuthStatusCode: '',
                addrUnit: '',
                addrBuildingName: '',
                addrLot: '',
                addrStreetName: '',
                addrSubdivision: '',
                addrBarangay: '',
                addrTown: '',
                addrMunicipality: '',
                addrProvince: '',
                contactPerson: '',
                transactionClassification: '',
                documentTypeCode: '',
                roundUpCode: '',
              },
            },
          ],
        },
      };
    case Action.destroySignUpElement.TRIGGER:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isTin: false,
          isId: false,
        },
      };
    case Action.findByAuthorization.SUCCESS:
      return {
        ...state,
        user: payload.data,
      };
    case Action.findByAuthorization.FAILURE:
      return {
        ...state,
        user: initialState.user,
      };
    case Action.isTinBranchCodeChange.TRIGGER:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isTin: false,
        },
      };
    case Action.isTin.SUCCESS:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isTin: true,
        },
      };
    case Action.isTin.FAILURE:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isTin: false,
        },
      };
    case Action.existId.SUCCESS:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isId: true,
        },
      };
    case Action.existId.FAILURE:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isId: false,
        },
      };

    case Action.getUser.SUCCESS:
      return { ...state, user: payload.data };
    case Action.getUser.FAILURE:
      return { ...state, user: initialState.user };

    case Action.changePassword.SUCCESS:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isPassword: 1,
        },
      };

    case Action.changePassword.FAILURE:
      return {
        ...state,
        checkElement: {
          ...state.checkElement,
          isPassword: 2,
        },
      };

    case Action.getCompany.SUCCESS:
      var companyString = JSON.stringify(initialState.company);
      var company = JSON.parse(companyString);

      Object.keys(payload.data).map((key) => {
        // employeeDto 인 것도 설정해주기
        if (key === 'employeeDtoList') {
          for (var i = 0; i < payload.data[key].length; i++) {
            let employeeFormat = { ...company.employee[0] };

            Object.keys(payload.data[key][i]).map((empKey) => {
              if (empKey === 'userDto') {
                company.employee[i]['user'] = payload.data[key][i][empKey];
                employeeFormat['user'] = payload.data[key][i][empKey];
                return;
              } else if (employeeFormat[empKey] === undefined) {
                return;
              }

              employeeFormat[empKey] = payload.data[key][i][empKey];
              if (i === 0) {
                company.employee[0] = employeeFormat;
              } else {
                company.employee.push(employeeFormat);
              }
            });
          }
        }
        if (company[key] == undefined) {
          return;
        }
        company[key] = payload.data[key];
      });

      var companyTypes = [
        { code: '0', text: 'VAT' },
        { code: '1', text: 'NON VAT' },
      ];

      for (var type of companyTypes) {
        if (type.code == company.companyTypeCode) {
          company.companyType = type;
        }
      }

      return { ...state, company };
    case Action.initCompany.TRIGGER:
      return {
        ...state,
        company: {
          companyNo: '',
          tin: '',
          branchCode: '',
          businessName: '',
          companyTypeCode: '',
          companyType: {},
          contactNo: '',
          email: '',
          registeredName: '',
          companyAuthStatusCode: '',
          addrUnit: '',
          addrBuildingName: '',
          addrLot: '',
          addrStreetName: '',
          addrSubdivision: '',
          addrBarangay: '',
          addrTown: '',
          addrMunicipality: '',
          addrProvince: '',
          contactPerson: '',
          transactionClassification: '',
          documentTypeCode: '',
          roundUpCode: '',
          employee: [
            {
              employeeNo: '',
              user: {
                userNo: '',
                contactNo: '',
                email: '',
                firstName: '',
                middleName: '',
                lastName: '',
                portalId: '',
                password: '',
                userAuthStatusCode: {},
                userTin: '',
                userBranchCode: '',
                certificateFileAddr: '',
              },
            },
          ],
        },
      };
    case Action.getStatisticsSum.SUCCESS:
      return { ...state, statisticsSum: payload };
    case Action.getStatisticsSumDetail.SUCCESS:
      return { ...state, statisticsSumDetail: payload };
    case Action.getStatisticsSumPopup.SUCCESS:
      return { ...state, statisticsSumPopup: payload };
    case Action.getStatisticsPeriod.SUCCESS:
      return {
        ...state,
        statisticsPeriod: payload,
        statisticsPeriodDetail: {
          size: 0,
          totalElements: 0,
          totalPages: 0,
          content: [],
        },
      };
    case Action.getStatisticsPeriodDetail.SUCCESS:
      return { ...state, statisticsPeriodDetail: payload };
    case Action.getStatisticsPeriodPopup.SUCCESS:
      return { ...state, statisticsPeriodPopup: payload };
    case Action.getStatisticsType.SUCCESS:
      return { ...state, statisticsType: payload };
    case Action.isStatisticsSumPopup.SUCCESS:
      return { ...state, isStatisticsSumPopup: payload };
    case Action.isStatisticsPeriodPopup.SUCCESS:
      return { ...state, isStatisticsPeriodPopup: payload };
    case Action.initStatistics.SUCCESS:
      return {
        ...state,
        isStatisticsSumPopup: false, // Statistics Sum 팝업 Flag
        isStatisticsPeriodPopup: false, // Statistics Period 팝업 Flag
        statisticsSum: '',
        statisticsSumDetail: {
          size: 0,
          totalElements: 0,
          totalPages: 0,
          content: [],
        },
        statisticsPeriod: [],
        statisticsPeriodDetail: {
          size: 0,
          totalElements: 0,
          totalPages: 0,
          content: [],
        },
        statisticsType: [],
        statisticsSumPopup: {
          size: 0,
          totalElements: 0,
          totalPages: 0,
          content: [],
        },
        statisticsPeriodPopup: {
          size: 0,
          totalElements: 0,
          totalPages: 0,
          content: [],
        },
      };
    case Action.searchUserList.SUCCESS:
      return { ...state, userList: payload.data.data };
    case Action.initTaxpayerDetail.TRIGGER:
      return { ...state, taxpayerDetail: {} };
    case Action.getTaxpayerDetail.SUCCESS:
      return { ...state, taxpayerDetail: payload };
    case Action.initVatMonthlyList.TRIGGER:
      return {
        ...state,
        vatMonthlyList: {
          size: 0,
          totalElements: 0,
          totalPages: 0,
          content: [],
        },
      };
    case Action.initVatMonthlyDetail.TRIGGER:
      return { ...state, vatMonthlyDetail: {} };
    case Action.initVatQuarterlyList.TRIGGER:
      return {
        ...state,
        vatQuarterlyList: {
          size: 0,
          totalElements: 0,
          totalPages: 0,
          content: [],
        },
      };
    case Action.initVatQuarterlyDetail.TRIGGER:
      return { ...state, vatQuarterlyDetail: {} };
    case Action.getVatMonthlyList.SUCCESS:
      return { ...state, vatMonthlyList: payload };
    case Action.getVatMonthlyDetail.SUCCESS:
      return { ...state, vatMonthlyDetail: payload };
    case Action.getVatQuarterlyList.SUCCESS:
      return { ...state, vatQuarterlyList: payload };
    case Action.getVatQuarterlyDetail.SUCCESS:
      return { ...state, vatQuarterlyDetail: payload };
    case Action.getJWS.SUCCESS:
      return { ...state, jwsInfo: payload };
    case Action.initJWS.SUCCESS:
      return {
        ...state,
        jwsInfo: {
          CompInvoiceId: '',
          IssueDtm: '',
          TransDtm: '',
          EisUniqueId: '',
          CorrYN: '',
          TransClass: '',
          DocType: '',
          Rmk: '',
          CorrectionCd: '',
          PrevUniqueId: '',
          SellerInfo: {
            Tin: '',
            BranchCd: '',
            Type: '',
            RegNm: '',
            BusinessNm: '',
            Email: '',
            RegAddr: '',
          },
          BuyerInfo: {
            Tin: '',
            BranchCd: '',
            RegNm: '',
            BusinessNm: '',
            Email: '',
            RegAddr: '',
            DevAddr: '',
            AirNum: '',
            AirNumDt: '',
            LadNum: '',
            LadNumDt: '',
          },
          ForCur: {
            Currency: '',
            ForexAmt: '',
            ConvRate: '',
          },
          ItemList: [
            {
              Nm: '',
              Desc: '',
              Qty: '',
              Unit: '',
              UnitCost: '',
              SalesAmt: '',
              RegDscntAmt: '',
              SpeDscntAmt: '',
              NetSales: '',
            },
          ],
          Discount: {
            ScAmt: '',
            PwdAmt: '',
            RegAmt: '',
            SpeAmt: '',
            Rmk: '',
          },
          TotNetSalesAmt: '',
          TotNetSalesAftDisct: '',
          VATAmt: '',
          WithholdIncome: '',
          WithholdBusVAT: '',
          WithholdBusPT: '',
          LocalTax: '',
          ServiceCharge: '',
          NetAmtPay: '',
          PtuNum: '',
          PtuExpDt: '',
          Min: '',
          Msn: '',
          VATSales: '',
          ExemptSales: '',
          ZeroSales: '',
          TotSalesAmt: '',
        },
      };
    default:
      return state;
  }
};
